/** Íconos de 16×16 en trazo, los mismos del appliance. Heredan el color del texto. */
type P = { className?: string };
const base = {
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const IcoPersonas = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="6" cy="5.5" r="2.5" />
    <path d="M1.5 13.5c.6-2.4 2.3-3.7 4.5-3.7s3.9 1.3 4.5 3.7M10.5 3.3a2.3 2.3 0 0 1 0 4.4M12 9.9c1.3.5 2.1 1.7 2.5 3.6" />
  </svg>
);
export const IcoCampana = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 11.5V7a4 4 0 0 1 8 0v4.5l1.2 1.2H2.8zM6.5 14h3" />
  </svg>
);
export const IcoDescarga = (p: P) => (
  <svg {...base} {...p}>
    <path d="M8 2.5v7.5M4.8 7L8 10.2 11.2 7M2.5 11.5v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1" />
  </svg>
);
export const IcoChevron = (p: P) => (
  <svg {...base} {...p}>
    <path d="M6 4l4 4-4 4" />
  </svg>
);
